import { render, staticRenderFns } from "./contract_vendors_info.vue?vue&type=template&id=71fc4ddc&scoped=true&"
import script from "./contract_vendors_info.vue?vue&type=script&lang=js&"
export * from "./contract_vendors_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc4ddc",
  null
  
)

export default component.exports